import React from "react";

export const IconCatering = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m5.9 23s-1.2 0-1.2-1.2c0-0.8 0.2-10.2 0.2-10.7 0.1-1.1 0.1-1.5-0.6-2.2-0.6-0.5-1.3-1.3-1.3-3 0-2.6 1.8-4.9 2.8-4.9s2.8 2.3 2.8 4.9c0 1.7-0.7 2.5-1.3 3-0.7 0.7-0.7 1.1-0.6 2.2 0 0.5 0.2 9.9 0.2 10.7 0 1.2-1.2 1.2-1.2 1.2m5-21.9v6.3c0 0.6-0.1 1.1 0.4 1.7s0.5 1 0.5 2.1c0 0.5-0.2 9.7-0.2 10.5 0 1.2 1.2 1.2 1.2 1.2m1.8001-21.8v6.3c0 0.6 0.1 1.1-0.4 1.7s-0.5 1-0.5 2.1c0 0.5 0.2 9.7 0.2 10.5 0 1.2-1.2 1.2-1.2 1.2m5.9999 0.1s1.2 0 1.2-1.2c0-0.8-0.2-8-0.2-8.4 0 0 1.3-2.6 1.3-5.9 0-1.4-0.3-4.2-1.7-6.1 0 0-0.2-0.3-0.7-0.3-0.6 0-0.8 0.5-0.8 0.8 0 2.8-0.1 11.1-0.1 11.1 0 0.5-0.2 8-0.2 8.8 0 1.2 1.2 1.2 1.2 1.2z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconCatering;
